import * as React from "react";
import { cn } from "@/lib/utils"

type CheckboxProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type" | "value" | "onChange" | "checked"
> & {
  label?: React.ReactNode;
  checked?: boolean | null;                 // allow null from forms
  onCheckedChange?: (checked: boolean) => void;
};

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, checked, onCheckedChange, id, ...props }, ref) => {
    const uid = React.useId();
    const inputId = id ?? uid;

    return (
      <div className={cn("inline-flex items-center gap-2", className
          )}>
        <input
          id={inputId}
          type="checkbox"
          ref={ref}
          className=
            // minimal checkbox styles; avoid text-input styles
            "h-4 w-4 rounded border border-input accent-sky-600 dark:accent-orange-400 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
            
        
          checked={!!checked}                             // coerce null→false
          onChange={(e) => onCheckedChange?.(e.target.checked)}
          {...props}
        />
        {label != null && (
          <label htmlFor={inputId} className="cursor-pointer select-none m-0">
            {label}
          </label>
        )}
      </div>
    );
  }
);

Checkbox.displayName = "Checkbox";
